// extracted by mini-css-extract-plugin
export default {"icon":"AddGpsIcon_icon__1pPqk"};